/* eslint-disable prefer-arrow-callback */
/* eslint-disable react/jsx-no-undef */
import React, { useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  Avatar,
  IconButton,
  Popover,
  Chip,
  Grid,
  Paper,
  Dialog,
  Slide,
  Button
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ChangePassword from '../../../DevelopmentComp/Others/ChangePassword';
// mocks_
import logoImage from '../../../media/corporate.png';
import account from '../../../_mock/account';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AccountPopover() {
  const navigate = useNavigate();

  const [open, setOpen] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    navigate('/');
    sessionStorage.clear();
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
    handleClose();
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
    <Button
          sx={{
            color: "#16b440ff",
            borderColor: "#16b440ff",
             padding: { xs: "4px 8px", sm: "4px 16px" }, 
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#16b440ff",
              color: "#fff",
              borderColor: "#16b440ff",
            },
            minWidth: { xs: "auto", sm: "initial" },
          }}
          variant="outlined"
          size="small"
          onClick={() =>
            window.open("https://tracking.teeparam.com/", "_blank")

            // Testing
            // window.open("http://targettest.asktek.net/teeparam.tracking.tcms.webapp/", "_blank")

            // Demo
            //  window.open("http://targetdemo.asktek.net/teeparam.tracking.tcms.demo.webapp/", "_blank")
          }
        >
           <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
    TRACK SHIPMENT&nbsp;
  </Box>
  <LocalShippingIcon sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }} />
        </Button>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          zIndex: 1500,
          ...(open && {
            '&:before': {
              zIndex: 1500,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
            },
          }),
        }}
      >
        <Chip
          avatar={<Avatar alt="Admin" src={account.photoURL} />}
          label={sessionStorage.getItem('UserName')}
          variant="outlined"
          size="medium"
        />
      </IconButton>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
              zIndex: 25000,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5, textAlign: 'center' }}>
          <Typography variant="subtitle2" noWrap>
            {sessionStorage.getItem('UserName')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {sessionStorage.getItem('UserEmail')}
          </Typography>
        </Box>
        <Divider>Company</Divider>
        <Grid container width={'100%'}>
          <Grid item xs={12} component={Paper} sx={{ backgroundColor: 'inherit', p: 1 }} elevation={0}>
            <Grid container>
              <Grid item xs={12} justifyContent={'center'} alignItems={'center'}>
                <Stack justifyContent={'center'} alignItems={'flex- start'} width={'100%'} height={'100%'}>
                  <Typography
                    variant="body2"
                    textAlign={'center'}
                    className="font_style_headerer2"
                    style={{ textTransform: 'uppercase', color: '#7C93C3' }}
                  >
                    {/* {sessionStorage.getItem('FiscalYear') === null
                      ? `${sessionStorage.getItem('CompanyName')} | ${sessionStorage.getItem('FiscalYear')}`
                      : sessionStorage.getItem('CompanyName')} */}
                      {`${sessionStorage.getItem('CompanyName')} `}
                  </Typography>
                  {/* {sessionStorage.getItem('userRole') !== 'Customer' && (
                    <Typography
                      variant="caption "
                      textAlign={'center'}
                      style={{ color: '#7C93C3' }}
                      className="font_style_branch"
                    >
                      {` Branch : ${sessionStorage.getItem('Branch_Name')}`}
                    </Typography>
                  )} */}
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Divider sx={{ borderStyle: 'dashed' }} />
        {sessionStorage.getItem('userRole') === 'Customer' && (
          <MenuItem onClick={handleDialogOpen} sx={{ m: 1 }}>
            Change Password
          </MenuItem>
        )}
        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>
      <Dialog open={dialogOpen} TransitionComponent={Transition} keepMounted aria-describedby="change-password-dialog">
        <ChangePassword setDialogOpen={setDialogOpen} />
      </Dialog>
    </>
  );
}
